import { useEffect, useState } from "react"
import { Breadcrumb } from "./Breadcrumb"

import { Model } from "../../models/model"
import NumberFormat from "react-number-format"
import { Link } from "react-router-dom"

export const AccountsToPay = (params) => {

    const [dataValues, setDataValues] = useState([])
    // const [dataMonths, setDataMonths] = useState([])
    const [openAll, setOpenAll] = useState(false)

    useEffect(() => {
        getData()
    }, [])

    const getData = async () => {

        const results = await Model.getAll({
            url: `reports/supplier-tracking`
        })

        // const { months, data } = results
        const { data } = results
        //setDataMonths(months)
        setDataValues(data)

    }

    return (
        <div className='p-container'>

            <div className="row mt-3">
                <div className="col d-flex flex-wrap justify-content-between">
                    <Breadcrumb
                        routes={[
                            { id: 1, name: 'Reportes', link: '/reportes', active: false },
                            { id: 2, name: 'Facturas por pagar', link: '/reportes/ap', active: true },
                        ]}
                    />
                </div>
            </div>

            <div className="p-report-container">
                <div className="row">
                    <div className="col table-responsive">
                        <table className="table table-bordered p-table-report">
                            <thead>
                                <HeadRows
                                    openAll={openAll}
                                    setOpenAll={setOpenAll}
                                />
                            </thead>
                            <tbody>
                                <ItemsRows
                                    data={dataValues}
                                    openAll={openAll}
                                    setOpenAll={setOpenAll}
                                />
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div >
    )

}

const HeadRows = ({ openAll, setOpenAll }) => {
    return (
        <>
            <tr>
                <th colSpan={3}></th>
                <th colSpan={4}>HOY (hasta DIC. 23)</th>
                <th colSpan={3}>PROYECTADO</th>
            </tr>
            <tr>
                <th>
                    <div className="d-flex justify-content-between">
                        <span></span>
                        <span>Proveedores</span>
                        <span>
                            {!openAll ?
                                <i
                                    className="bi bi-caret-down-fill"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => setOpenAll(!openAll)}
                                ></i>
                                :
                                <i
                                    className="bi bi-caret-up-fill"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => setOpenAll(!openAll)}
                                ></i>
                            }
                        </span>
                    </div>
                </th>
                <th>Proyectos</th>
                <th>Presupuesto</th>
                <th>Total a pagar</th>
                <th>Pagado</th>
                <th>Por pagar</th>
                <th>ENE. 24</th>
                <th>FEB. 24</th>
                <th>MAR. 24</th>
            </tr>
        </>
    )
}

const ItemsRows = ({ data, openAll }) => {
    return (
        <>
            {data?.map(it => (
                <ProjectList
                    key={it.id}
                    it={it}
                    projects={it.projects}
                    openAll={openAll}
                />
            ))}
        </>
    )
}

const ProjectList = ({ projects, it, openAll }) => {
    const [open, setOpen] = useState(false)

    return (
        <>
            <tr className={it?.type ? 'title' : ''}>
                <th>
                    <span>{it?.supplier}</span>
                    <span className="ms-2">
                        {!open ?
                            <i
                                className="bi bi-caret-down-fill"
                                style={{ cursor: 'pointer' }}
                                onClick={() => setOpen(!open)}
                            ></i>
                            :
                            <i
                                className="bi bi-caret-up-fill"
                                style={{ cursor: 'pointer' }}
                                onClick={() => setOpen(!open)}
                            ></i>
                        }
                    </span>
                </th>
                <th>{it?.detail}</th>
                <th>
                    <NumberFormat
                        style={{ textAlign: 'right' }}
                        displayType={'text'}
                        value={it.total_ppto || 0}
                        thousandSeparator=','
                        decimalSeparator='.'
                        prefix='S/ '
                        decimalScale={2}
                        fixedDecimalScale={2}
                    />
                </th>
                <th>
                    <NumberFormat
                        displayType={'text'}
                        value={it.proyectado_total || 0}
                        thousandSeparator=','
                        decimalSeparator='.'
                        prefix='S/ '
                        decimalScale={2}
                        fixedDecimalScale={2}
                    />
                </th>
                <th>
                    <NumberFormat
                        displayType={'text'}
                        value={it.proyectado_pagado || 0}
                        thousandSeparator=','
                        decimalSeparator='.'
                        prefix='S/ '
                        decimalScale={2}
                        fixedDecimalScale={2}
                    />
                </th>
                <th>
                    <NumberFormat
                        displayType={'text'}
                        value={it.proyectado_por_pagar || 0}
                        thousandSeparator=','
                        decimalSeparator='.'
                        prefix='S/ '
                        decimalScale={2}
                        fixedDecimalScale={2}
                    />
                </th>
                <th>
                    <NumberFormat
                        displayType={'text'}
                        value={0}
                        thousandSeparator=','
                        decimalSeparator='.'
                        prefix='S/ '
                        decimalScale={2}
                        fixedDecimalScale={2}
                    />
                </th>
                <th>
                    <NumberFormat
                        displayType={'text'}
                        value={0}
                        thousandSeparator=','
                        decimalSeparator='.'
                        prefix='S/ '
                        decimalScale={2}
                        fixedDecimalScale={2}
                    />
                </th>
                <th>
                    <NumberFormat
                        displayType={'text'}
                        value={0}
                        thousandSeparator=','
                        decimalSeparator='.'
                        prefix='S/ '
                        decimalScale={2}
                        fixedDecimalScale={2}
                    />
                </th>
            </tr >
            {(open || openAll) && projects?.map((item, index) => (
                <tr key={index}>
                    <td></td>
                    <td className="referencia">
                        <Link
                            to={`/ppto/${item?.id}`}
                            target="_blank"
                            style={{
                                fontSize: '11px',
                                textTransform: 'uppercase',
                                textDecoration: 'none'
                            }}
                        >
                            {item?.referencia}
                        </Link>
                    </td>
                    <td>
                        <NumberFormat
                            displayType={'text'}
                            value={item.total_ppto || 0}
                            thousandSeparator=','
                            decimalSeparator='.'
                            prefix='S/ '
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                    </td>
                    <td>
                        <NumberFormat
                            displayType={'text'}
                            value={item.proyectado_total || 0}
                            thousandSeparator=','
                            decimalSeparator='.'
                            prefix='S/ '
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                    </td>
                    <td>
                        <NumberFormat
                            displayType={'text'}
                            value={item.proyectado_pagado || 0}
                            thousandSeparator=','
                            decimalSeparator='.'
                            prefix='S/ '
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                    </td>
                    <td>
                        <NumberFormat
                            displayType={'text'}
                            value={item.proyectado_por_pagar || 0}
                            thousandSeparator=','
                            decimalSeparator='.'
                            prefix='S/ '
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                    </td>
                    <td>
                        <NumberFormat
                            displayType={'text'}
                            value={0}
                            thousandSeparator=','
                            decimalSeparator='.'
                            prefix='S/ '
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                    </td>
                    <td>
                        <NumberFormat
                            displayType={'text'}
                            value={0}
                            thousandSeparator=','
                            decimalSeparator='.'
                            prefix='S/ '
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                    </td>
                    <td>
                        <NumberFormat
                            displayType={'text'}
                            value={0}
                            thousandSeparator=','
                            decimalSeparator='.'
                            prefix='S/ '
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                    </td>
                </tr>
            ))
            }
        </>
    )
}